import * as React from "react";
import { Part } from "./Lines";
import { Table, Pane } from "evergreen-ui";
import { DXFSpace } from "../nodedxf2";
import { ObjectTree } from "../../Misc/react-object-tree";
import { useAPI } from '../../Api';
const CanDraw = ["LINE", "ARC", "CIRCLE", "POLYGON"];
const Benable = ["LINE"];
export function Details(props) {
    var _a;
    // console.log("Detail Props: ", props);
    const drawing = props.drawing;
    // const [totals, setTotals] = React.useState({});
    const [shapes, setShapes] = React.useState(drawing.Drawables
        ? (_a = drawing.Drawables) === null || _a === void 0 ? void 0 : _a.filter((cc) => CanDraw.includes(cc.named))
        : []);
    const [torender, setToRender] = React.useState([]);
    const [lengths, setLengths] = React.useState(null);
    React.useEffect(() => {
        setToRender(shapes.filter((shape) => {
            return (!(shape instanceof DXFSpace.DXFOBJECT) &&
                Benable.includes(shape.named) &&
                shape.Type != "IGNORE");
        }));
    }, [shapes]);
    React.useEffect(() => {
        props.onActionsChange(drawing.calcContour());
    }, [torender]);
    let API = useAPI();
    return (torender.length > 0 && (React.createElement(Pane, null,
        React.createElement(Table, null,
            React.createElement(Table.Head, null,
                React.createElement(Table.HeaderCell, null),
                React.createElement(Table.HeaderCell, null)),
            React.createElement(Table.Body, { height: 240 }, torender &&
                torender.map((shape, i) => {
                    let c = shape;
                    return (React.createElement(Part, { isSelected: props.ids && props.ids.indexOf(c.id) >= 0, key: c.id, ids: c.id, selectIds: props.setIds, Type: c.named, Action: c.Type, Length: c.length(), actions: ["CUT", "FOLD", "IGNORE"], onChange: (e) => {
                            let key = shapes.findIndex((e) => e.id === shape.id);
                            if (key >= 0) {
                                shapes[key].Type = e;
                                setShapes([...shapes]);
                            }
                        } }));
                }))),
        lengths && API.isAdmin && (React.createElement(Pane, { border: "1px solid red", borderRadius: "10px", padding: "10px", height: "fit-content" },
            React.createElement(ObjectTree, { value: lengths, level: 4, style: { maxHeight: "400px", overflow: "scroll", width: "600px" } }))))));
}
